/*
* 工单回访管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { Row, Col, message, Table, Input, Rate } from 'antd';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    isGTscreenWidth,
    GetButtonActionName,
} from '../../incs/FunHelper.js';

const MODULENAME = CNF.navItems[2].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[2].submenu[1].ptn;

const Lists = (props) => {

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'wo/visits/' + record.key;
        switch (action) {
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, props.isRefresh, uri);
                break;
            default:
                break;

        }
    }

    const columns = [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        { title: '工单编号', dataIndex: 'number', key: 'number', fixed: 'left', width: 150, },
        {
            title: '客户评分', key: 'rate',
            render: (record) => {
                return <Rate value={record.rate} style={{ fontSize: 13 }} />
            }
        },
        { title: '客户评价', dataIndex: 'evaluation', key: 'evaluation', ellipsis: true, },
        { title: '回访人员', dataIndex: 'visit_displayname', key: 'visit_displayname', },
        { title: '回访日期', dataIndex: 'visit_date', key: 'visit_date', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                // scroll={{ x: winWidth}} 
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            number: '',
            visitDisplayname: '',

        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeNumber = (e) => { this.setState({ number: e.target.value, }); this.search(); }
    changeVisitDisplayname = (e) => { this.setState({ visitDisplayname: e.target.value, }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'number': this.state.number,
            'visit_displayname': this.state.visitDisplayname,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}wo/visits${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 2 : 3}>
                        <Input
                            placeholder='工单编号'
                            onChange={this.changeNumber}
                            value={this.state.number}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft, }}>
                        <Input
                            placeholder='回访人员'
                            onChange={this.changeVisitDisplayname}
                            value={this.state.visitDisplayname}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT